export interface INcsScoresReport {
    centerId: number;
    centerAlias: string;
    isAdpPartner: boolean;
    isNkrParticipant: boolean;
    centerState: string;
    clCu: number;
    abWlp: string;
    wlpOffers: number;
    wlpDeclines: number;
    declineRatio: number;
    chains12: number;
    oldChains12: number;
    chains24: number;
    declines12: number;
    oChains24: number;
    ofvChains24: number;
    nonofvChains24: number;
    fvCume: number;
    oChainsRatio24: number;
    declineRatio12: number;
    oldDeclineRatio12: number;
    ofvChainsRatio24: number;
    adpStarts: number;
    nddStarts: number;
    fcstADPStarts: number;
    fcstNDDStarts: number;
    adpEnds: number;
    nddEnds: number;
    fcstADPEnds: number;
    fcstNDDEnds: number;
    totalStarts: number;
    totalEnds: number;
    nddncSa: number;
    adpncSa: number;
    summaryNCSa: number;
    detailsNCSa: number;
    ncSb: number;
    ncSu: number;
    ncsDeficit: number;
    fcstTotalStarts: number;
    fcstTotalEnds: number;
    fcstNDDNCS: number;
    fcstADPNCS: number;
    fcstNCS: number;
    ofvTarget: number;
    nfvTarget: number;
    anyAnatomy: boolean;
    anatomyRestrictions: string;
    csfvStartersLast24: number;
    cssvStartersLast24: number;
    csCompPairsLast24: number;
    csRemoteSVOrPDLast24: number;
    anyAnatomyDeclineRatioBonus: number;
    compScore: number;
    shareOfCompScore: number;
    shareOfFloat: number;
    targetChainEnds: number;
    rank: number;
    donorAcceptanceBonus: number;
}